import { useEffect, useRef, useState } from "react";
import client from "./api/client";
import { errorText, toastError, toastSuccess } from "./toastHelper";

// Shared migrate/undo plumbing for the V2->V3 banner. `onChange` runs (and is
// awaited) after success so the caller refreshes however it manages state.
export default function useV3OfferMigration({ team, calendarEventId, onChange }) {
  const [migrating, setMigrating] = useState(false);
  const mounted = useRef(true);
  const url = `/teams/${team.id}/calendar_events/${calendarEventId}/v3_offer_migration`;

  useEffect(() => () => { mounted.current = false; }, []);

  const run = (request, expectedStatus, successMessage, failureMessage) => {
    setMigrating(true);
    return request()
      .then((response) => {
        if (response?.status !== expectedStatus) {
          if (mounted.current) toastError(failureMessage);
          return undefined;
        }
        return Promise.resolve(onChange()).then((refreshed) => {
          if (refreshed === false) return;
          if (mounted.current) toastSuccess(successMessage);
        });
      })
      .catch((e) => { if (mounted.current) toastError(errorText(e, failureMessage)); })
      .finally(() => { if (mounted.current) setMigrating(false); });
  };

  const migrate = () => run(
    () => client.post(url),
    201,
    "Offers migrated to V3.",
    "Couldn't migrate these offers. Please try again.",
  );

  const undo = () => run(
    () => client.delete(url),
    204,
    "V3 migration undone.",
    "Couldn't undo the migration. Please try again.",
  );

  return { migrating, migrate, undo };
}
